type iconParams = {
  color: string;
  inverted: boolean;
};

const SortIcon = ({ color, inverted }: iconParams): JSX.Element => (
  <svg
    fill={color}
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    width="12px"
    height="12px"
    viewBox="0 0 24 24"
    stroke={color}
    strokeWidth="0.00036678"
    transform={inverted ? 'rotate(180)' : ''}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <g>
        <path d="M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19z" />
      </g>
    </g>
  </svg>
);
export default SortIcon;
